module.exports = __webpack_public_path__ + "static/media/reklame.79f13cf3.png";